// Marca do painel esquerdo de /login e /signup. O painel é sempre escuro, então
// usa a logomarca do tema escuro (`theme.calculatedLogoDark`, que cai na do
// tema claro quando só ela foi configurada). Se a imagem não carregar, volta
// ao monograma + nome do mockup — nunca texto no lugar de uma logo que existe.
import React, { useState } from "react";
import { useTheme } from "@material-ui/core/styles";

const AuthBrand = ({ classes, appName, appLogoFavicon }) => {
  const theme = useTheme();
  const logo =
    typeof theme.calculatedLogoDark === "function" ? theme.calculatedLogoDark() : "";
  const [broken, setBroken] = useState(false);

  if (logo && !broken) {
    return (
      <div className={classes.heroBrand}>
        <img
          className={classes.brandLogo}
          src={logo}
          alt={appName || "pulse"}
          onError={() => setBroken(true)}
        />
      </div>
    );
  }

  return (
    <div className={classes.heroBrand}>
      <div className={classes.brandMark}>
        {appLogoFavicon ? <img src={appLogoFavicon} alt="" /> : "P"}
      </div>
      <div className={classes.brandName}>{appName || "pulse"}</div>
    </div>
  );
};

export default AuthBrand;
